<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style scoped lang="scss">
#app{
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue